// // MFAInput.js
// import React, { useEffect, useRef } from "react";
// import PropTypes from "prop-types";

// const MFAInput = ({ length = 6, onComplete, autoFocus = false }) => {
//   const inputs = useRef([]);

//   useEffect(() => {
//     if (autoFocus && inputs.current[0]) {
//       inputs.current[0].focus();
//     }
//   }, [autoFocus]);

//   const handleChange = (e, idx) => {
//     const { value } = e.target;
//     if (value.length === 1 && idx < length - 1) {
//       inputs.current[idx + 1].focus();
//     }
//     const code = inputs.current.map((input) => input.value).join("");
//     if (code.length === length) {
//       onComplete(code);
//     }
//   };

//   const handleKeyDown = (e, idx) => {
//     if (e.key === "Backspace" && !inputs.current[idx].value && idx > 0) {
//       inputs.current[idx - 1].focus();
//     }
//   };

//   return (
//     <div className="flex justify-center space-x-2 py-4">
//       {Array.from({ length }).map((_, idx) => (
//         <input
//           key={idx}
//           ref={(el) => (inputs.current[idx] = el)}
//           type="text"
//           maxLength="1"
//           className="w-12 h-12 border border-gray-300 text-center text-xl rounded-md"
//           onChange={(e) => handleChange(e, idx)}
//           onKeyDown={(e) => handleKeyDown(e, idx)}
//         />
//       ))}
//     </div>
//   );
// };

// MFAInput.propTypes = {
//   length: PropTypes.number,
//   onComplete: PropTypes.func.isRequired,
//   autoFocus: PropTypes.bool,
// };

// export default MFAInput;

// MFAInput.js
import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";

const MFAInput = ({ length = 6, onComplete, autoFocus = false, message }) => {
  const inputs = useRef([]);

  useEffect(() => {
    if (autoFocus && inputs.current[0]) {
      inputs.current[0].focus();
    }
  }, [autoFocus]);

  const handleChange = (e, idx) => {
    const { value } = e.target;
    if (value.length === 1 && idx < length - 1) {
      inputs.current[idx + 1].focus();
    }
    const code = inputs.current.map((input) => input.value).join("");
    if (code.length === length) {
      onComplete(code);
    }
  };

  const handleKeyDown = (e, idx) => {
    if (e.key === "Backspace" && !inputs.current[idx].value && idx > 0) {
      inputs.current[idx - 1].focus();
    }
  };

  return (
    <div className="flex flex-col items-center">
      {message && (
        <p className="mb-2 text-agLightGray text-sm w-56 text-center">
          {message}
        </p>
      )}
      <div className="flex justify-center space-x-2 py-4">
        {Array.from({ length }).map((_, idx) => (
          <input
            key={idx}
            ref={(el) => (inputs.current[idx] = el)}
            type="text"
            maxLength="1"
            className="w-12 h-12 border border-gray-300 text-center text-agLightGray text-xl rounded-md"
            onChange={(e) => handleChange(e, idx)}
            onKeyDown={(e) => handleKeyDown(e, idx)}
          />
        ))}
      </div>
    </div>
  );
};

MFAInput.propTypes = {
  length: PropTypes.number,
  onComplete: PropTypes.func.isRequired,
  autoFocus: PropTypes.bool,
  message: PropTypes.string, // Added prop type for the message
};

export default MFAInput;
